import { fetchProjectDataTrees } from './dataTreesActions';
import { closeAllModals } from './modalActions';

export const SET_FILE_LIST = 'SET_FTP_LIST';
export const SET_DIR_LIST = 'SET_DIR_LIST';
export const FTP_TAG = 'ftp';

export const setFileList = (list) => {
  return {
    type: SET_FILE_LIST,
    list
  }
};

export const setDirList = (list) => {
  return {
    type: SET_DIR_LIST,
    list
  }
};

export const fetchFileList = (dir) => {
  return async (dispatch, getState, { apiClient }) => {
    dispatch(setFileList(false));
    const results = await apiClient.call(FTP_TAG, 'list', {dir});
    dispatch(setFileList(results));
  };
};

export const fetchDirList = () => {
  return async (dispatch, getState, { apiClient }) => {
    const results = await apiClient.call(FTP_TAG, 'root');
    dispatch(setDirList(results));
  };
};

export const download = (dir, file, endCallback) => {
  return async (dispatch, getState, { apiClient }) => {
    const response = await apiClient.call(FTP_TAG, 'download', {dir, file});
    const blob = new Blob(["\ufeff", response]);
    const url = URL.createObjectURL(blob);
    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = file;

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);

    endCallback && endCallback(file, false);
  }
};

export const upload = (dir, file, participationId, equipmentId, endCallback) => {
  return async (dispatch, getState, { apiClient }) => {
    await apiClient.call(FTP_TAG, 'upload', {participationId, equipmentId, dir, file});

    endCallback && endCallback(file, false);

    dispatch(fetchProjectDataTrees(getState().projects.single.active.id));
    dispatch(closeAllModals());
  }
};



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/data/fileImport/ftpActions.js